const routes = {
    home: '/',
};

export default routes;
